import React from "react";

export default function NafedComingSoon({ title }) {
  return (
    <>
      <style>{`
        .coming-page {
          display: grid;
          gap: 18px;
        }

        .coming-hero {
          background: white;
          border-radius: 18px;
          padding: 26px;
          box-shadow: 0 8px 24px rgba(15,23,42,.06);
          border: 1px solid #eef2f7;
        }

        .coming-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #eef6ff;
          color: #064a9b;
          border: 1px solid #dbeafe;
          border-radius: 999px;
          padding: 8px 12px;
          font-size: 11px;
          font-weight: 950;
          letter-spacing: .09em;
          text-transform: uppercase;
        }

        .coming-hero h1 {
          margin: 18px 0 0;
          font-size: 30px;
          font-weight: 950;
          color: #071f45;
        }

        .coming-hero p {
          margin: 10px 0 0;
          color: #64748b;
          line-height: 1.8;
          max-width: 850px;
          font-size: 14px;
        }

        .coming-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 14px;
        }

        .coming-card {
          background: white;
          border-radius: 16px;
          padding: 20px;
          box-shadow: 0 8px 24px rgba(15,23,42,.06);
          border: 1px solid #eef2f7;
        }

        .coming-card span {
          display: block;
          width: 46px;
          height: 46px;
          border-radius: 14px;
          background: #f1f7ff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 23px;
          margin-bottom: 14px;
        }

        .coming-card b {
          display: block;
          font-size: 15px;
          color: #071f45;
        }

        .coming-card p {
          margin: 8px 0 0;
          color: #64748b;
          font-size: 13px;
          line-height: 1.7;
        }

        .coming-note {
          background: #fff7ed;
          border: 1px solid #fed7aa;
          color: #9a3412;
          border-radius: 16px;
          padding: 18px;
          font-size: 14px;
          font-weight: 750;
          line-height: 1.7;
        }

        @media(max-width:1200px) {
          .coming-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      `}</style>

      <div className="coming-page">
        <section className="coming-hero">
          <div className="coming-badge">NAFED Head Office Module</div>

          <h1>{title}</h1>

          <p>
            This module is already connected with the NAFED Head Office sidebar.
            Detailed approval workflow, live Firestore data, automated mail queue,
            reports and MIS download features can be added here without changing
            the main dashboard layout.
          </p>
        </section>

        <section className="coming-grid">
          <div className="coming-card">
            <span>📊</span>
            <b>Live Dashboard</b>
            <p>Connect this page with Firestore collection and show real-time data.</p>
          </div>

          <div className="coming-card">
            <span>✅</span>
            <b>Approval Workflow</b>
            <p>Role-wise approval, reject, return and remark system can be added.</p>
          </div>

          <div className="coming-card">
            <span>📧</span>
            <b>Mail Automation</b>
            <p>Every approval can create a mail notification queue automatically.</p>
          </div>

          <div className="coming-card">
            <span>📄</span>
            <b>Reports & MIS</b>
            <p>PDF, Excel, MIS and dashboard report download can be added.</p>
          </div>
        </section>

        <div className="coming-note">
          Next development step: replace this placeholder with a dedicated module page.
          Sidebar and route structure will remain the same.
        </div>
      </div>
    </>
  );
}